import { Stack, Text } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import {
  E_MAIL,
  FIRST_NAME,
  LAST_NAME,
  ROLE,
  STATUS,
} from '../../utils/constants';
import { defaultHeaderStyles } from '../../styles/Common';

export const columnWidths = () => `

  .member-fname,
  .member-lname {
    width: 15%;
  }
  
  .member-email {
    width: 20%
  }
  
  .member-roles {
    width: 25%;
  }
  
  .status-container {
    width: 15%;
  }

  .action-icons {
    width: 10%;
  }

`;

const StyledHeader = styled.div`
  ${defaultHeaderStyles};
  ${columnWidths};
  border: 0;
`;

const colTitles = [
  { title: FIRST_NAME, className: 'member-fname' },
  { title: LAST_NAME, className: 'member-lname' },
  { title: E_MAIL, className: 'member-email' },
  { title: ROLE, className: 'member-roles' },
  { title: STATUS, className: 'status-container' },
  { title: '', className: 'action-icons' },
];

const MemberColHeader = () => {
  return (
    <StyledHeader>
      {colTitles.map((column) => (
        <Stack
          className={column.className}
          flexDirection="column"
          justifyContent="center"
          key={column.title}
        >
          <Text variant="body-large" color="primary.60" weight="light">
            {column.title}
          </Text>
        </Stack>
      ))}
    </StyledHeader>
  );
};

export default MemberColHeader;
